import { Component, OnInit, inject } from '@angular/core';
import {
  OrderService,
  OrderDetails,
  OrderBasketItem,
  OrderBasketDetails,
  BasketItemType,
  CartV2Service,
  CheckoutService,
  MarketplaceSubType,
} from '@fgb/core';
import { map, Observable, shareReplay } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'fgb-marketplace-purchase-success',
  templateUrl: './marketplace-purchase-success-page.component.html',
  styleUrl: './marketplace-purchase-success-page.component.scss',
})
export class MarketplacePurchaseSuccessPageComponent implements OnInit {
  orderDetails$: Observable<OrderDetails>;
  basketItems$: Observable<OrderBasketDetails[]>;
  firstBasketItem$: Observable<OrderBasketItem | null>;
  basketItemType = BasketItemType;
  marketplaceSubType = MarketplaceSubType;

  private readonly orderService = inject(OrderService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly cartService = inject(CartV2Service);
  private readonly checkoutService = inject(CheckoutService);

  ngOnInit() {
    const orderId = this.activatedRoute.snapshot.queryParamMap.get('purchaseOrderId') || '';

    this.orderDetails$ = this.orderService.getOrderDetails(orderId).pipe(shareReplay({ bufferSize: 1, refCount: false }));
    this.basketItems$ = this.orderDetails$.pipe(
      map((od: OrderDetails) => od.Basket.map((basket) => ({ ...basket, Items: this.mapUniquePurchases(basket.Items) })))
    );
    this.firstBasketItem$ = this.basketItems$.pipe(
      map((basketItems) => (basketItems.length > 0 ? basketItems[0].Items[0] : null))
    );

    // Only clear basket if not a single purchase
    if (this.checkoutService.items().length > 1) {
      this.cartService.removeAll();
    }
    this.checkoutService.clearAll();
  }

  private mapUniquePurchases(items: OrderBasketItem[]): OrderBasketItem[] {
    let uniquePurchases: Map<number, OrderBasketItem> = new Map();
    items.forEach((item) => {
      const existing = uniquePurchases.get(item.Id);
      if (existing) {
        uniquePurchases.set(item.Id, {
          ...existing,
          Quantity: existing.Quantity + item.Quantity,
          Merchant: existing.Merchant + item.Merchant,
          Ecash: existing.Ecash + item.Ecash,
          Points: existing.Points + item.Points,
        });
      } else {
        uniquePurchases.set(item.Id, { ...item });
      }
    });
    return Array.from(uniquePurchases.values());
  }
}
